import { FabricChannel } from '@atlaskit/analytics-listeners';

export const ANALYTICS_CHANNEL: FabricChannel.aiMate = FabricChannel.aiMate;

const REMIX_SOURCES = [
	'remix',
	'inlineRovoFromRemix',
	'remixModalFromToolbar',
	'remixModalFromBlockControls',
	'remixModalFromBlockMenu',
	'remixModalFromFloatingToolbar',
	'remixModalFromViewPageFloatingToolbar',
	'remixModalFromViewPageNudge',
	'remixModalFromNudge',
	'remixModalFromObjectLevelSidebar',
	'remixModalFromPasteMenu',
	'remixStagingArea',
	'remixModalFromMediaInserts',
] as const;

type RemixInteractionSource = (typeof REMIX_SOURCES)[number];
type ScheduledChatInteractionSource = 'scheduledChatRenderer';

type GoogleDocCreateInteractionSource = 'googleDocCreateRenderer';

type JiraEpicsSuggestInteractionSource = 'jiraEpicsSuggestRenderer';
type StudioUpdateAgentDraftInteractionSource = 'studioUpdateAgentDraftRenderer';

export type InteractionSource =
	| RemixInteractionSource
	| GoogleDocCreateInteractionSource
	| ScheduledChatInteractionSource
	| JiraEpicsSuggestInteractionSource
	| StudioUpdateAgentDraftInteractionSource
	| 'chatInput'
	| 'editor'
	| 'embeddedAgentConversationStarters'
	| 'emptyStateSuggestions'
	| 'followUps'
	| 'inlineRovo'
	| 'movedOver'
	| 'ntpSuggestion'
	| 'profileCardConversationStarters'
	| 'rightClickDefine'
	| 'rightClickSummarize'
	| 'slackSendChannelMessageRenderer'
	| 'urlParam'
	| 'viewAgentConversationStarters'
	| 'resendMessage'
	| 'editMessage'
	| 'smartCreate'
	| 'resumptionRenderer'
	| 'executePythonRenderer'
	| 'askQuestionRenderer'
	| 'planCompleteRenderer'
	| 'jsmCreateRequestActionUnifiedRenderer'
	| 'jsmLivechatActionRenderer'
	| 'jsmCreateSpaceAction'
	| 'jsmSelectHardwareTypesAction'
	| 'multipleChoiceQuestionsToolRenderer'
	| 'agenticPlanToolRenderer'
	| 'jiraIssueTransitionRenderer'
	| 'jiraIssueAssignRenderer'
	| 'confluencePageCommentRenderer'
	| 'confluencePageCreateRenderer'
	| 'confluenceFolderCreateRenderer'
	| 'confluencePageAddLabelRenderer'
	| 'confluencePageRenameRenderer'
	| 'confluencePageMoveRenderer'
	| 'jiraVersionCreateRenderer'
	| 'jiraPlansAddDependencyRenderer'
	| 'jiraPlansRemoveDependencyRenderer'
	| 'jiraPlansAddProgramBoardRenderer'
	| 'jiraPlansDeleteProgramBoardRenderer'
	| 'jiraPlansCreateReleaseRenderer'
	| 'jiraPlansCreateWorkItemRenderer'
	| 'jiraPlansManageFeaturesRenderer'
	| 'jiraPlansUpdateWorkSourceRenderer'
	| 'jiraCreateSprintAction'
	| 'jiraStartSprintAction'
	| 'jiraMoveToSprintAction'
	| 'jiraWorkflowEditorRenderer'
	| 'updateAgentRenderer'
	| 'confluenceAifcAdfUpdateRenderer'
	| 'deepResearchConfluencePageCreateRenderer'
	| 'jiraIssueDeleteRenderer'
	| 'jiraIssueMoveRenderer'
	| 'studioLandingPageRedirectRenderer'
	| 'jsmJourneyBuilderActionRenderer';

// Widened to Set<InteractionSource> so .has() accepts any InteractionSource directly
export const REMIX_INTERACTION_SOURCES: Set<InteractionSource> = new Set(REMIX_SOURCES);

// Which context a follow up was triggered from
export type FollowUpSource =
	| 'ai-mate'
	| 'extension'
	| 'none'
	| 'page-summary'
	| 'reading-aids'
	| 'sain'
	| 'ai-smart-button-dynamic-surface'
	| string;

export enum AUTOSUGGEST_SOURCE {
	ROVO_CHAT = 'rovo-chat',
	CONFLUENCE_AIFC = 'confluence-aifc',
	CONFLUENCE_AIFC_SLIDES = 'confluence-aifc-slides',
	CONFLUENCE_AIFC_WHITEBOARD = 'confluence-aifc-whiteboard',
	CONFLUENCE_AIFC_DATABASE = 'confluence-aifc-database',
	CONFLUENCE_AIFC_LIVE_DOC = 'confluence-aifc-live-doc',
}
